/**
 * CreateAccountConfirmation.jsx
 * Created by michaelbray on 2/13/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../../../sharedComponents/icons/Icons';

const propTypes = {
    email: PropTypes.string,
    sendAccountConfirmationEmail: PropTypes.func
};

export default class CreateAccountConfirmation extends React.Component {
    constructor(props) {
        super(props);

        this.resendConfirmationEmail = this.resendConfirmationEmail.bind(this);
    }

    componentDidMount() {
        this.header.focus();
    }

    resendConfirmationEmail(e) {
        e.preventDefault();

        this.props.sendAccountConfirmationEmail();
    }

    render() {
        return (
            <div>
                <div
                    className="rec-modal-title rec-modal-title-center"
                    ref={(header) => this.header = header}>
                    Check Your Email
                </div>
                <div className="rec-acct-modal-media">
                    <Icons.IconEmail />
                </div>
                <p>An email has been sent. Once you confirm your email, you will be able to set a password for your account.</p>
                <p><strong>{this.props.email}</strong></p>
                <button
                    onClick={this.resendConfirmationEmail}
                    className="rec-button-primary"
                    title="Resend Email"
                    aria-label="Resend Email">
                    Resend Email
                </button>
            </div>
        );
    }
}

CreateAccountConfirmation.propTypes = propTypes;
